export const COLORS = {
	HEADER_BACKGROUND_COLOR: '#151515',
	HEADER_FONT_COLOR: '#e5e5e5',
	HEADER_MOBILE_BACKGROUND_COLOR: 'white',
	HEADER_MOBILE_EXPANDED_BACKGROUND_COLOR: 'white',
	HEADER_MOBILE_FONT_COLOR: '#121617',
};

export const HEADER_ICONS = 'white';

export const LOGO = {
	EXPANDED: 'https://static.millesima.com/s3/next/svg/logo-millesima-n-2021.svg',
};
